import { defineNuxtPlugin } from '#app';
import {
  captureAttributionFromUrl,
  captureMetaTestCodeFromUrl,
} from '~/composables/useAttribution';

// Captures first-touch UTM/click-id parameters from the landing URL into
// localStorage on every client-side boot. Subsequent visits keep the
// original attribution as long as the entry is still fresh (30-day TTL).
//
// Also stashes `?fbe_test_event_code=TESTxxx` into sessionStorage so QA
// submits route through Meta's Test Events tab. No-op when the parameter
// is absent.

export default defineNuxtPlugin(() => {
  captureAttributionFromUrl();
  captureMetaTestCodeFromUrl();
});
